import { useContext } from "react";
import RopTable, {
  TableRowType,
} from "../../../../main/components/RopTable/RopTable";
import { MainContext } from "../../../../main/context/MainContextProvider";
import {
  datePtBrDayOfWeekShortWithoutYear,
  getDayOfMonthMiddayUTC,
  getNumDaysMonth,
} from "../../../dashboard/helpers/format-number";

export default function PerformanceTable() {
  const { relatorioMensal } = useContext(MainContext);

  const numDaysMonth = getNumDaysMonth(
    relatorioMensal?.mesDeReferencia ?? 0,
    relatorioMensal?.anoDeReferencia ?? 0
  );

  const data = Array.from({ length: numDaysMonth }, (_, i) => {
    const dia = i + 1;

    const data = getDayOfMonthMiddayUTC(
      dia,
      relatorioMensal?.mesDeReferencia ?? 0,
      relatorioMensal?.anoDeReferencia ?? 0
    );

    const prPrevisto =
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]?.prPrevisto ??
      null;
    const prRealizado =
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]
        ?.prRealizado ?? null;
    const irradiacaoPrevista =
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]
        ?.irradiacaoPrevista ?? null;
    const irradiacaoRealizada =
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]
        ?.irradiacaoRealizada ?? null;

    return {
      data,
      prPrevisto,
      prRealizado,
      irradiacaoPrevista,
      irradiacaoRealizada,
    };
  });
  const total = data.reduce(
    (acc, row) => {
      acc.prPrevisto += row.prPrevisto ?? 0;
      acc.prRealizado += row.prRealizado ?? 0;
      acc.irradiacaoPrevista += row.irradiacaoPrevista ?? 0;
      acc.irradiacaoRealizada += row.irradiacaoRealizada ?? 0;
      return acc;
    },
    {
      prPrevisto: 0,
      prRealizado: 0,
      irradiacaoPrevista: 0,
      irradiacaoRealizada: 0,
    }
  );
  const media = {
    prPrevisto: total.prPrevisto / numDaysMonth,
    prRealizado: total.prRealizado / numDaysMonth,
    irradiacaoPrevista: total.irradiacaoPrevista / numDaysMonth,
    irradiacaoRealizada: total.irradiacaoRealizada / numDaysMonth,
  };

  const numberWithOptionalSuffixOrSymbol = (
    value: number | null,
    suffix?: string
  ): string => {
    if (value === null) {
      return "-";
    }
    if (!suffix) {
      return value.toFixed(2);
    }
    return `${value.toFixed(2)} ${suffix}`;
  };
  const irradianciaSuffix = "MW/m2";

  const tableRows: TableRowType[] = data.map((row) => {
    return {
      rowItems: [
        {
          item: <>{datePtBrDayOfWeekShortWithoutYear(row.data)}</>,
          isMobile: true,
          align: "center",
        },
        {
          item: <>{numberWithOptionalSuffixOrSymbol(row.prPrevisto)}</>,
          isMobile: true,
          align: "center",
        },
        {
          item: <>{numberWithOptionalSuffixOrSymbol(row.prRealizado)}</>,
          isMobile: false,
          align: "center",
        },
        {
          item: (
            <>
              {numberWithOptionalSuffixOrSymbol(
                row.irradiacaoPrevista,
                irradianciaSuffix
              )}
            </>
          ),
          isMobile: false,
          align: "center",
        },
        {
          item: (
            <>
              {numberWithOptionalSuffixOrSymbol(
                row.irradiacaoRealizada,
                irradianciaSuffix
              )}
            </>
          ),
          isMobile: false,
          align: "center",
        },
      ],
    };
  });

  const tableFooter: TableRowType = {
    rowItems: [
      {
        item: <>Média</>,
        isMobile: true,
        align: "center",
      },
      {
        item: <>{numberWithOptionalSuffixOrSymbol(media.prPrevisto)}</>,
        isMobile: true,
        align: "center",
      },
      {
        item: <>{numberWithOptionalSuffixOrSymbol(media.prRealizado)}</>,
        isMobile: false,
        align: "center",
      },
      {
        item: (
          <>
            {numberWithOptionalSuffixOrSymbol(
              media.irradiacaoPrevista,
              irradianciaSuffix
            )}
          </>
        ),
        isMobile: false,
        align: "center",
      },
      {
        item: (
          <>
            {numberWithOptionalSuffixOrSymbol(
              media.irradiacaoRealizada,
              irradianciaSuffix
            )}
          </>
        ),
        isMobile: false,
        align: "center",
      },
    ],
  };

  return (
    <>
      <RopTable
        sxCardBox={{
          height: "100%",
          width: "100%",
          minHeight: "400px",
          display: "flex",
          flexDirection: "column",
          margin: "0px",
        }}
        itemRows={tableRows}
        itemFooter={tableFooter}
        itemsHeaders={[
          {
            item: "Data",
            align: "center",
            isMobile: true,
          },
          {
            item: "PR Previsto",
            isMobile: true,
          },
          {
            item: "PR Real",
            align: "center",
            isMobile: false,
          },
          {
            item: "Irradiação Prevista",
            align: "center",
            isMobile: false,
          },
          {
            item: "Irradiação Real",
            align: "center",
            isMobile: false,
          },
        ]}
      />
    </>
  );
}
